import type { KeyboardLayoutObject, SimpleKeyboard } from 'react-simple-keyboard';
import { KeyboardLayoutType, getWritableInputTypesConfig, getLayoutsByLanguage } from '../utils/KeyUtils';
import { SPECIAL_KEYS } from '../utils/constants';

const DEFAULT_LAYOUT_INDEX = 0;

const prepareKeyboardLayout = (layout: KeyboardLayoutObject) => ({
  ...layout,
  default: [...layout.default.slice(0, -1), `${SPECIAL_KEYS.NEXT_KEYBOARD} ${layout.default[layout.default.length - 1]}`],
  shift: [...layout.shift.slice(0, -1), `${SPECIAL_KEYS.NEXT_KEYBOARD} ${layout.shift[layout.shift.length - 1]}`],
});

const multiKeyboards = (keyboard: SimpleKeyboard) => {
  keyboard.registerModule('multiKeyboards', (module: any) => {
    const { type, language, layoutType } = keyboard.getOptions();
    if (!getWritableInputTypesConfig(language)[type]?.layout) {
      const layouts = getLayoutsByLanguage(language);
      module.index = layoutType === KeyboardLayoutType.ALTERNATE ? layouts.length - 1 : DEFAULT_LAYOUT_INDEX;
      module.fn = { handleButtonClicked: keyboard.handleButtonClicked };

      const defaultLayout = layouts.at(module.index);

      keyboard.setOptions({
        layoutName: 'default',
        layout: layouts.length > 1 ? prepareKeyboardLayout(defaultLayout) : defaultLayout,
      });

      keyboard.handleButtonClicked = (...args) => {
        const [button] = args;
        if (button === SPECIAL_KEYS.NEXT_KEYBOARD) {
          const nextIndex = (module.index + 1) % layouts.length;
          module.index = nextIndex;
          keyboard.setOptions({
            layoutName: 'default',
            layout: prepareKeyboardLayout(layouts.at(module.index)),
          });
        }
        module.fn.handleButtonClicked.call(keyboard, ...args);
      };
    }
  });
};

export default multiKeyboards;
